import {
  addSubStep,
  allInfoUser,
  nextStep,
  resetUserData,
  setAppointmentUrl,
  setReturnedValue,
  setUserData,
  stopLoading,
  userArea
} from "../actions";
import { createStep } from "./scenario-manager";
import ListPersons from "../components/ListPersons";
import {
  fetcher,
  getListUserComplete,
  getReturnedValue,
  initValues,
  validateRdv
} from "./fetcher";
import Upload from "../components/Upload";

export const getUserData = (retryNumber = 0) => {
  return dispatch => {
    fetcher(true)
      .get("ajax/verif_info_user.php", {
        searchParams: {
          idlieu: initValues().idlieu ? initValues().idlieu : ""
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.success === "ok") {
          dispatch(
            setUserData({
              userId: json.identifiant_user,
              firstName: json.nom_user,
              lastName: json.prenom_user,
              civility: json.abreviation_civilite,
              email: json.email_user
            })
          );
          if (json.url_site) {
            dispatch(setAppointmentUrl(json.url_site));
          } else {
            dispatch(setAppointmentUrl(""));
          }
          document.cookie = "user_connected=" + true;
        } else {
          dispatch(allInfoUser({}));
          dispatch(resetUserData());
          document.cookie = "user_connected=" + false;
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
        if (retryNumber > 0) {
          dispatch(getUserData(retryNumber - 1));
        }
      });
  };
};

export const isLoggedIn = () => {
  return (dispatch, getState) => {
    dispatch(getUserData());
    const userData = getState().user.userData;
    if (Object.keys(userData).length > 0) {
      dispatch(onLoggedIn(userData.userId));
    }
  };
};

export const onLoggedIn = userId => {
  return (dispatch, getState) => {
    dispatch(setReturnedValue({ userId }));
    const isUpload = getReturnedValue("upload", false);
    let subStep;
    if (isUpload) {
      subStep = createStep({
        label: "",
        component: {
          type: Upload,
          label: ""
        }
      });
    } else {
      dispatch(validateRdv(userId));
      subStep = createStep({
        label: "",
        component: {
          type: ListPersons,
          label: ""
        },
        data: {
          fetchSource: getListUserComplete,
          keyValue: "userDetails"
        }
      });
    }

    dispatch(addSubStep(getState().activeStep.step, subStep));
    dispatch(nextStep(getState().steps));
    dispatch(userArea(true));
  };
};
